<mat-card>
  <form [formGroup]="b2Form" (ngSubmit)="onSubmit()" class="b1-form p-6 bg-white rounded-lg shadow-md">
    <div class="grid grid-cols-12 gap-6">
      <ng-container *ngFor="let field of fields">
        <div class="col-span-6" *ngIf="field.type == 'text'">
          <mat-label>{{ field.key | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="field.key" [type]="field.type" />
            <mat-error *ngIf="b2Form.get(field.key)?.hasError('required')">
              {{ field.label }} is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6" *ngIf="field.type == 'select'">
          <mat-label>{{ field.key | translate }}</mat-label>

          <!-- <mat-form-field appearance="outline" class="w-full">
                <mat-select [formControlName]="field.key" >
              <mat-option
                *ngFor="let option of field.options"
                [value]="option"
                >{{ option }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="b2Form.get(field.key)?.hasError('required')">
              {{ field.label }} is required
            </mat-error>
          </mat-form-field> -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-select [formControlName]="field.key" (selectionChange)="field.onChange?.()">
              <mat-option *ngFor="let option of optionsMap[field.optionKey]" [value]="option.value">
                {{ option.label || option }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="b2Form.get(field.key)?.hasError('required')">
              {{ field.label }} is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6" *ngIf="field.type == 'textarea'">
          <mat-label>{{ field.key | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <textarea matInput [formControlName]="field.key" [type]="field.type" rows="1"></textarea>
            <mat-error *ngIf="b2Form.get(field.key)?.hasError('required')">
              {{ field.label }} is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6" *ngIf="field.type === 'date'">
          <mat-label>{{ field.key | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="picker" [formControlName]="field.key" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="b2Form.get(field.key)?.hasError('required')">
              {{ field.label }} is required
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="mt-6 text-right">
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>
  </form>
</mat-card>